/*
 * @Description: 
 * @Author: dezhi
 * @Date: 2021-05-19 10:04:29
 * @LastEditTime: 2021-05-28 16:58:18
 * @LastEditors: dezhi
 */
export const routeList = [
  { name: 'Login' },
  { name: 'Phone' },
  { name: 'Wx' },
  { name: 'Bind' },
  { name: 'Admission' },
]